import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { mediaQuery, Spacings } from '@styles/index';

const Title = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 72px;
  line-height: 89px;
  text-align: center;
  opacity: 0.4;
  color: ${({ $color }) => $color};
  ${mediaQuery.uptoTablet} {
    padding-right: ${Spacings.SPACING_5B};
  }
`;

const SectionNameMobile = forwardRef(({ title, color }, ref) => {
  return (
    <Title ref={ref} $color={color}>
      {title}
    </Title>
  );
});

SectionNameMobile.displayName = 'SectionNameMobile';

SectionNameMobile.propTypes = {
  title: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired
};

export default SectionNameMobile;
